import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import ItemsService from "../../services/items";
import GlobalVariable from "../../../../client/src/services/globalVar";
import { format } from "date-fns";
import { Tooltip, Input, Space,Select,Divider } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { iconSet, IcomoonReact } from "../PrimeReact";
import { AiFillDelete } from "react-icons/ai";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { TabView, TabPanel } from 'primereact/tabview';
import ListofItems from "../Items/ListofItems";
import { PlusOutlined } from '@ant-design/icons';
import {  Modal } from 'antd';
import {  Tag } from "antd";

const AssetManagement = () => {
  const is = new ItemsService();
    //   useEffect(() => {
    //   return () => {
    //     Object.values(is.controllers).forEach((c) => c.abort());
    //     is.controllers = {}; 
    //   };
    // }, []);
  const inputRef = useRef(null);
  const [name, setName] = useState('');
  const [asset, setAsset] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const toast = React.useRef(null);
  const [assetTypes, setAssetTypes] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [newAsset, setNewAsset] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [location, setLocation] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [assignedTo, setAssignedTo] = useState([]);
  const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);
  const [isProcess, setIsProcess] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortName, setSortName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [first1, setFirst1] = useState(0);
  const [newLocation, setNewLocation] = useState("");
  const [newAssignedTo, setNewAssignedTo] = useState("");
  const [isCustomEntry, setIsCustomEntry] = useState(false);
  const [assetID, setAssetID] = useState('');
  const [expandedRows, setExpandedRows] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [getConfigNumber, setgetConfigNumber] = useState("");

  const defaultValue = {
    assetName: "",
    category: "",
    purchaseDate: "",
    assetType: "",
    status: "",
    location: "",
    assignedTo: "",
    empid: "",
    assetValue: "",
    description: "",
  };

  const {
    control,
    register,
    reset,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm({ mode: "onChange", defaultValue });

  const statusOptions = [
    { label: "In Stock", value: "InStock" },
    { label: "In Repair", value: "InRepair" },
    { label: "In Use", value: "InUse" },
  ];

  const getAssetManageData = (
    page,
    sizePerPage,
    searchVal,
    sortName,
    sortOrder
  ) => {
    setIsProcess(true);
    const data = {
      InputParams: {
        TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
        Status: "",
      },
      ServerSearchables: {
        draw: 1,
        searchData: searchVal || "",
        orderByColumn: sortName,
        orderBy: sortOrder,
        currentPage: 1,
        pageSize: sizePerPage,
        pageNumber: page,
      },
    };
    is.GetAssetManagementSearchData(data).then((res) => {
      setIsProcess(false);
      setAsset(res.data.data.assetList);
      setTotalRecords(res.data.data.serverSearchables.recordsTotal);
    });
  };

  const onCustomPage1 = (event) => {
    setFirst1(event.first);
    const val = event.page + 1;
    const size = event.rows;
    setSizePerPage(size);
    setPage(val);
    // GetLoanDataSearch(val, size, searchVal, "", "", "");
    getAssetManageData(val, size, searchVal, "", "", "");

  };

  const onSort = (event) => {
    setLazyParams(event);
  };

  const handleRowClick = (event) => {
    // setRowData(event.data);
  };

  const [lazyParams, setLazyParams] = useState({
    first: first1,
    rows: sizePerPage,
    page: page,
    sortField: sortName,
    sortOrder: sortOrder,
  });

  const onSubmit = (data) => {
    const datas = {
      AssetID: assetID.assetID || 0,
      AssetCode: getConfigNumber,
      AssetType: data.assetType,
      CategoryName: data.category,
      AssetName: data.assetName,
      PurchaseDate: format(new Date(data.purchaseDate), "yyyy-MM-dd"),
      Location: data.location,
      AssignedTo: data.assignedTo || null,
      AssetValue: data.assetValue,
      AssigneeCode: data.empid || null,
      Description: data.description,
      Status: data.status,
      TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
      CreatedOn: format(new Date(), "yyyy-MM-dd"),
      CreatedBy: GlobalVariable.userDet.appUser.appuserID.toString(),
    };
    is.SaveAsset(datas).then((res) => {
      toast.current.show({
        severity: "success",
        detail: res.data.message,
      });
      setVisible(false);
      reset();
      getAssetManageData(page, sizePerPage, searchVal, "", "", "");
    });
  };

const GenerateConfigNumber = () => {
  const data= {
    "TenantID" : 109,
    "ServiceName" : "Asset"
} 
is.GenerateConfigNumber(data).then((res) => {
  setgetConfigNumber(res.data.data)
})
}

  const onCancel = () => {
    // setValue("status", "");
    // setValue("purchaseDate", "");
    // setValue("location", "");
    setIsCustomEntry(false);
    setVisible(false);
    reset(defaultValue);
    setSelectedAsset(null);
    setSelectedCategories(null);
    setSelectedLocation(null);
    setSelectedAssignedTo(null);
    setEditIndex(null);
  };

  const GetAssetTypeLists = () => {
    is.GetAssetTypeLists(GlobalVariable.userDet.tenantDetail.tenantID).then(
      (res) => {
        setAssetTypes(res.data.data.typeList);
        let cat = res.data.data.categoryList.map((item) => ({
          label: item,
          value: item,
          selectedDates: item,
        }))
        let loc = res.data.data.locationList.map((item) => ({
          label: item,
          value: item,
          selectedDates: item,
        }))
        let assTo = res.data.data.assignList.map((item) => ({
          label: item,
          value: item,
          selectedDates: item,
        }))
        setCategories(cat);
        setLocation(loc);
        setAssignedTo(assTo);
      }
    );
  };

  const keySearch = (e) => {
    setSearchVal(e.target.value);
    if (e.key === "Enter") {
      const searched = e.target.value;
      getAssetManageData(1, sizePerPage, searched, sortName, sortOrder, "", "");
    }
    if (e.type === "keyup") {
      if (e.target.value === "") {
        getAssetManageData(1, sizePerPage, "", sortName, sortOrder, "", "");
      }
    }
  };
  const statusTemplate = (rowData) => {
    let status = rowData.status.toUpperCase();
    let statusClass

    switch (status) {
        case "INSTOCK":
            statusClass = "blue"; 
            break;
        case "INUSE":
            statusClass = "green"; 
            break;
        case "INREPAIR":
            statusClass = "red"; 
            break;
        default:
            statusClass = "gray"; 
    }

    return (
        <Tag bordered={false} color={statusClass}>
            {status}
        </Tag>
    );
};
  const handleAssignedToChange = (e) => {
    setSelectedAssignedTo(e.value);
    const employeeId = e.split("(")[1]?.replace(")", "");
  if(employeeId){
    setIsCustomEntry(true);
    setValue("empid", employeeId)
  } else {
    setIsCustomEntry(false);
    setValue("empid", "");
  }
  };

  const handleEdit = (rowData, index) => {
    setAssetID(rowData)
    setEditIndex(index);
    setVisible(true);
  
    Object.entries(rowData).forEach(([key, value]) => {
      if (key === "purchaseDate") {
        setValue(key, new Date(value)); 
      } else {
        setValue(key, value);
      }
    });
    if(rowData.assigneeCode){
      setValue("empid", rowData.assigneeCode);
      setIsCustomEntry(true)
    }
    setSelectedAsset(rowData.assetType || null);
    setSelectedCategories(rowData.categoryName);
    setSelectedLocation(rowData.location);
    setSelectedAssignedTo(rowData.assignedTo);
    setgetConfigNumber(rowData.assetCode);
   
  };
  

  const addLocation = () => {
    if (
      newLocation.trim() &&
      !location.some((item) => item.value === newLocation)
    ) {
      const newLocationObj = { label: newLocation, value: newLocation };
      setLocation([...location, newLocationObj]);
      setNewLocation("");
      setSelectedLocation(newLocation);
      setValue("location", newLocation);
    }
  };

  const addAssignedTo = () => {
    setIsCustomEntry(false);
    setValue("empid", "")
    if (
      newAssignedTo.trim() &&
      !assignedTo.some((item) => item.value === newAssignedTo)
    ) {
      const newAssignedToObj = { label: newAssignedTo, value: newAssignedTo };
      setAssignedTo([...assignedTo, newAssignedToObj]);
      setNewAssignedTo("");
      setSelectedAssignedTo(newAssignedTo);
      setValue("assignedTo", newAssignedTo);
    }
  };

  const handleDelete = (rowData) => {
    is.deleteasset(GlobalVariable.userDet.tenantDetail.tenantID,rowData.assetID).then((res) => {
      if (res.status === 200) {
        toast.current.show({
          severity: "success",
          detail: res.data.message,
        });
      }
    getAssetManageData(page, sizePerPage, searchVal, "", "", "");
    })
  };

  const addAssetType = () => {
    if (
      newAsset.trim() &&
      !assetTypes.some((item) => item.value === newAsset)
    ) {
      const newAssetObj = { label: newAsset, value: newAsset };
      setAssetTypes([...assetTypes, newAssetObj]);
      setNewAsset("");
      setSelectedAsset(newAsset);
      setValue("assetType", newAsset);
    }
  };

  const allowExpansionPurchaseReturn = (rowData) => {
    return rowData.assetAssignedHistory.length;
  };
 const rowExpansionTemplatePurchaseReturn = (data) => {
    return (
      <div className="">
        <DataTable
          stripedRows
          value={data.assetAssignedHistory}
          className="expand-table "
        >
          <Column field="assetName" header="Asset Name"></Column>
          <Column field="categoryName" header=" Category Name"></Column>
          <Column field="assignedDate" header="Assigned Date" body={(row) => (
            <div>
              {format(
                      new Date(row.assignedDate),
                      GlobalVariable.userDet.tenantConfig.dateFormat
                    )}
            </div>
          )} ></Column>
          <Column field="assigneeCode" header="Empoyee Id" body={(row) => row.assigneeCode ? row.assigneeCode : "-"}/>
          <Column field="assignedTo" header="Assigned To" body={(row) => row.assignedTo ? row.assignedTo : "-" }/>
          <Column field="location" header="Assigned Location" />
          <Column field="status" header="Status" body={(e) => statusTemplate(e)} />
          
        </DataTable>
      </div>
    );
  };
  const addCategory = () => {
    if (
      newCategory.trim() &&
      !categories.some((item) => item.value === newCategory)
    ) {
      const newCategoryObj = { label: newCategory, value: newCategory };
      setCategories([...categories, newCategoryObj]);
      setNewCategory("");
      setValue("category", newCategory); 
    }
  };
  const handleConfirmDelete = (rowData) => {
    confirmDialog({
      message: "Are you sure you want to delete this asset?",
      className: "pAdj deletecircle",
      header: "Confirm Deletion",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => handleDelete(rowData),
      reject: () => console.log("Cancelled"),
    });
  };

  useEffect(() => {
    getAssetManageData(page, sizePerPage, searchVal, "", "", "");
    GetAssetTypeLists();
    GenerateConfigNumber();
  }, []);

  return (
    <>
      <TabView className="customer-tabs">
        <TabPanel header="Inventory" >
          <ListofItems />
        </TabPanel>
        {/* <TabPanel header="Asset Management">
          <Toast ref={toast} />
          <ConfirmDialog />
          <div className="card card-borderless cc-greyCard-custm mb-3">
            <div className="ms-2 my-2 me-2 ">
              <div className="d-flex justify-content-between flex-wrap align-items-center">
                <h4 className="m-0">Asset Management</h4>

                <div className="d-flex justify-content-end text-t-primary kk-table-header kk-header-sec  cc-font-size-14">
                  <div className="col">
                    <Space.Compact className="my-auto">
                      <Input
                        addonBefore={<SearchOutlined />}
                        allowClear
                        placeholder="Search"
                        value={searchVal}
                        onChange={(e) => keySearch(e)}
                        onKeyUp={(e) => keySearch(e)}
                      />
                    </Space.Compact>
                    <button
                      className="btn btn-primary ms-2"
                      onClick={() => {setVisible(true);setSelectedStatus('');setSelectedCategories('');setSelectedLocation('')}}
                    >
                      {" "}
                      <i className="pi pi-plus"></i> Add Asset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="account-table ">
            <DataTable
              totalRecords={totalRecords}
              stripedRows
              className=" hdeEst cc-greyCard-custm1"
              tableStyle={{ minWidth: "100%" }}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              lazy
              paginator
              loading={isProcess}
              first={first1}
              rows={sizePerPage}
              onPage={onCustomPage1}
              onSort={onSort}
              sortField={lazyParams.sortField}
              sortOrder={lazyParams.sortOrder}
              rowsPerPageOptions={[10, 20, 50, totalRecords]}
              onRowClick={handleRowClick}
              emptyMessage="No data available"
              value={asset}
              expandedRows={expandedRows}
              onRowToggle={(e) => setExpandedRows(e.data)}
              rowExpansionTemplate={rowExpansionTemplatePurchaseReturn}
              responsiveLayout="scroll"
            >
              <Column expander={allowExpansionPurchaseReturn} style={{ width: "4rem" }} />
              <Column field="assetName" header="Asset Name" />
              <Column field="categoryName" header="Category" />
              <Column field="purchaseDate" header="Purchase Date" body={(row) => ( <div> {format(new Date(row.purchaseDate),GlobalVariable.userDet.tenantConfig.dateFormat)} </div> )}/>
              <Column field="assigneeCode" header="Empoyee Id" body={(row) => row.assigneeCode ? row.assigneeCode : "-"}/>
              <Column field="assignedTo" header="Assigned To" body={(row) => row.assignedTo ? row.assignedTo : "-" }/>
              <Column field="location" header="Location" />
              <Column field="status" header="Status" body={(e) => statusTemplate(e)} />
              <Column header="Actions"
                body={(rowData, { rowIndex }) => (
                  <div className="flex gap-2">
                    <Tooltip
                      target=".pointerr"
                      content="Edit"
                      position="left"
                    />
                    <Tooltip
                      target=".icon-lock"
                      content="Delete"
                      position="top"
                    />
                    <IcomoonReact
                      iconSet={iconSet}
                      color="#444"
                      size={20}
                      icon="edit"
                      className="pointer"
                      onClick={(e) => handleEdit(rowData, rowIndex)}
                    />
                    <AiFillDelete
                      style={{ fontSize: "1.4rem" }}
                      className="pointer icon-lock ms-1 text-danger"
                      onClick={(e) => handleConfirmDelete(rowData)}
                    />
                  </div>
                )}
              />
            </DataTable>
          </div>

          <Modal
            title={editIndex !== null ? "Edit Asset" : "Add Asset"}
            open={visible}
            style={{ width: "60vh" }}
            breakpoints={{ "960px": "75vw" }}
            onCancel={onCancel}
            footer={null}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="my-3 row">
                <label className="col-form-label col-sm-4 required">
                  Asset Name
                </label>
                <div className="col-sm-8 ps-2">
                  <input
                    type="text"
                    name="assetName"
                    className="form-control"
                    {...register("assetName", { required: true })}
                  />
                </div>
                {errors.assetName && (
                  <p className="text-danger text-end mb-0">
                    This field is required
                  </p>
                )}
              </div>

              <div className="mb-3 row align-items-center">
                <div className="row pe-0">
                  <label className="col-form-label col-sm-4 required">
                    Category
                  </label>
                  <div className="col pe-0">
                    <Select
                      className="cust-form-control p-0"
                      placeholder="select / add category"
                      {...register("category", { required: true })}
                      value={selectedCategories}
                      onChange={(value) => {
                        setSelectedCategories(value);
                        setValue("category", value, { shouldValidate: true });
                      }}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider className="m-0" />
                          <Space className="ant-drop-search">
                            <Input
                              placeholder="Add new category"
                              className="form-control"
                              ref={inputRef}
                              value={newCategory}
                              onChange={(e) => setNewCategory(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                            />
                            <Button
                              style={{ width: "5.5rem", padding: "0.5rem 0" }}
                              type="text"
                              icon={<PlusOutlined />}
                              onClick={addCategory}
                              disabled={!newCategory.trim()}
                            >
                              Add item
                            </Button>
                          </Space>
                        </>
                      )}
                      options={categories.map((item) => ({
                        label: item.label,
                        value: item.value,
                      }))}
                    />
                  </div>
                  {errors.category && (
                    <p className="text-danger text-end mb-0 p-0">
                      {errors.category.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-form-label col-sm-4 required">
                  Purchase Date
                </label>
                <div className="col-sm-8 ps-2">
                  <Controller
                    name="purchaseDate"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Calendar
                        {...field}
                        showIcon
                        placeholder="select date"
                        className="form-control p-0"
                        {...register("purchaseDate")}
                        maxDate={new Date()}
                      />
                    )}
                  />
                </div>
                {errors.purchaseDate && (
                  <p className="text-danger text-end mb-0">
                    This field is required
                  </p>
                )}
              </div>

              <div className="mb-3 row">
                <label className="col-form-label col-sm-4 required">
                  Status
                </label>
                <div className="col-sm-8 ps-2">
                  <Controller
                    name="status"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Dropdown
                        {...field}
                        options={statusOptions}
                        value={selectedStatus}
                        placeholder="Select Status"
                        optionLabel="label"
                        className="form-control"
                        optionValue="value"
                        onChange={(e) => {field.onChange(e.value); setSelectedStatus(e.value)}}
                      />
                    )}
                  />
                </div>
                {errors.status && (
                  <p className="text-danger text-end mb-0">
                    This field is required
                  </p>
                )}
              </div>

              <div className="mb-3 row align-items-center">
                <div className="row pe-0">
                  <label className="col-form-label col-sm-4 required">
                    Location
                  </label>
                  <div className="col pe-0">
                      <Select
                      className="cust-form-control p-0"
                      placeholder="select / add location"
                      {...register("location", { required: true })}
                      value={selectedLocation}
                      onChange={(value) => {setValue("location", value, { shouldValidate: true }); setSelectedLocation(value)}}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider className="m-0" />
                          <Space className="ant-drop-search">
                            <Input
                              placeholder="Add new location"
                              className="form-control"
                              ref={inputRef}
                              value={newLocation}
                              onChange={(e) => setNewLocation(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                            />
                            <Button
                              style={{ width: "5.5rem", padding: "0.5rem 0" }}
                              type="text"
                              icon={<PlusOutlined />}
                              onClick={addLocation}
                              disabled={!newLocation.trim()}
                            >
                              Add item
                            </Button>
                          </Space>
                        </>
                      )}
                      options={location.map((item) => ({
                        label: item.label,
                        value: item.value,
                      }))}
                    />
                  </div>
                  {errors.location && (
                    <p className="text-danger text-end mb-0 p-0">
                      {errors.location.message}
                    </p>
                  )}
                </div>
              </div>

             { selectedStatus === "InUse" && <>
              <div className="mb-3 row align-items-center">
                <div className="row pe-0">
                  <label className="col-form-label col-sm-4 required">
                    Assigned To
                  </label>
                  <div className="col pe-0">
                      <Select
                      className="cust-form-control p-0"
                      placeholder="select / add assignee"
                      showSearch
                      {...register("assignedTo", { required: selectedStatus === "InUse" })}
                      value={selectedAssignedTo}
                      onChange={(value) => {setValue("assignedTo", value, { shouldValidate: true });  handleAssignedToChange(value); selectedAssignedTo(value)}}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider className="m-0" />
                          <Space className="ant-drop-search">
                            <Input
                              placeholder="Add new assignee"
                              className="form-control"
                              ref={inputRef}
                              value={newAssignedTo}
                              onChange={(e) => setNewAssignedTo(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                            />
                            <Button
                              style={{ width: "5.5rem", padding: "0.5rem 0" }}
                              type="text"
                              icon={<PlusOutlined />}
                              onClick={addAssignedTo}
                              disabled={!newAssignedTo.trim()} 
                            >
                              Add item
                            </Button>
                          </Space>
                        </>
                      )}
                      options={assignedTo.map((item) => ({
                        label: item.label,
                        value: item.value,
                      }))}
                    />
                  </div>
                  {errors.assignedTo && (
                    <p className="text-danger text-end mb-0 p-0">
                      {errors.assignedTo.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-form-label col-sm-4 required">
                  Employee Id
                </label>
                <div className="col-sm-8 ps-2">
                  <input
                    type="text"
                    name="empid"
                    className="form-control"
                    {...register("empid", { required: selectedStatus === "InUse" })}
                    disabled={isCustomEntry}
                  />
                </div>
                {errors.empid && (
                  <p className="text-danger text-end mb-0">
                    This field is required
                  </p>
                )}
              </div>
             </>
             }
              <div className="mb-3 row">
                <label className="col-form-label col-sm-4 required">
                  Asset Value
                </label>
                <div className="col-sm-8 ps-2">
                  <input
                    type="number"
                    name="assetValue"
                    className="form-control"
                    {...register("assetValue", { required: true })}
                  />
                </div>
                {errors.assetValue && (
                  <p className="text-danger text-end mb-0">
                    This field is required
                  </p>
                )}
              </div>

              <div className="mb-3 row">
                <label className="col-form-label col-sm-4 ">Description</label>
                <div className="col-sm-8 ps-2">
                  <input
                    type="textarea"
                    name="description"
                    className="form-control"
                    {...register("description", { required: false })}
                  />
                </div>
                {errors.description && (
                  <p className="text-danger text-end mb-0">
                    This field is required
                  </p>
                )}
              </div>

              <div className="text-end">
                <Button
                  type="button"
                  label="Cancel"
                  className="btn btn-danger me-2"
                  onClick={onCancel}
                />
                <Button
                  type="submit"
                  label={editIndex !== null ? "Update" : "Add"}
                  className="btn btn-primary"
                />
              </div>
            </form>
          </Modal>
        </TabPanel> */}
      </TabView>
    </>
  );
};

export default AssetManagement;
